export const getCampaigns = (state) => state.collect.campaigns;
export const getAssignments = (state) => state.collect.assignments;
export const getRevisits = (state) => state.collect.revisit;
export const getCollectCount = (state) => state.collect.collectCount;
